import "./index.css"
import CalendarGrid from "../calendar-grid";
import { useState, useMemo } from "react";
import Button from "../button";
import { schedulePost } from "../../functions/schedulePost";


function IdeaScheduler({display,close,id,linkedinStatus}) {
    const [monthToDisplay,SetMonthToDisplay] = useState(new Date());
    const [selectedScheduledDate,SetSelectedScheduledDate] = useState(null);
    const [selectedTime, setSelectedTime] = useState("09:00");

    const moveToNextMonth = () => {
      let currentMonth = monthToDisplay;
      let newMonthToDisplay = new Date(currentMonth.getFullYear(), currentMonth.getMonth() + 1, 1);
      SetMonthToDisplay(newMonthToDisplay);
    }

    const moveBackAMonth = () => {
      const now = new Date();
      if (monthToDisplay.getFullYear() === now.getFullYear() && monthToDisplay.getMonth() === now.getMonth()) return;
      let currentMonth = monthToDisplay;
      let newMonthToDisplay = new Date(currentMonth.getFullYear(), currentMonth.getMonth() - 1, 1);
      SetMonthToDisplay(newMonthToDisplay);
    }

    const isToday = useMemo(() => {
      if (!selectedScheduledDate) return false;
      const now = new Date();
      return monthToDisplay.getFullYear() === now.getFullYear()
          && monthToDisplay.getMonth() === now.getMonth()
          && selectedScheduledDate === now.getDate();
    }, [monthToDisplay, selectedScheduledDate]);

    const timeOptions = useMemo(() => {
      const all = Array.from({ length: 48 }, (_, i) => {
        const h = String(Math.floor(i / 2)).padStart(2, "0");
        const m = i % 2 === 0 ? "00" : "30";
        return `${h}:${m}`;
      });
      if (!isToday) return all;
      const now = new Date();
      const nowMinutes = now.getHours() * 60 + now.getMinutes();
      return all.filter(t => {
        const [h, m] = t.split(":").map(Number);
        return h * 60 + m > nowMinutes;
      });
    }, [isToday]);

    const effectiveTime = timeOptions.includes(selectedTime) ? selectedTime : (timeOptions[0] || "09:00");

    const buildSchedulingDate = (date) => {
        const [h, m] = effectiveTime.split(":").map(Number);
        let schedulingDate = new Date(monthToDisplay.getFullYear(), monthToDisplay.getMonth(), date);
        schedulingDate.setHours(h, m, 0, 0);
        return schedulingDate;
    }

    const logScheduledDate = async(date) => {
        await schedulePost(id, buildSchedulingDate(date), false);
    }

    const logScheduledDateWithLinkedin = async(date) => {
        await schedulePost(id, buildSchedulingDate(date), true);
    }

    return <div id="idea-scheduler-holder" style={{display:display}}>
        <div id="idea-scheduler">
        <div className="idea-schedule-header">
          <h2 className="idea-schedule-month">{monthToDisplay.toLocaleString('default', { month: 'long' })} {monthToDisplay.getFullYear()}</h2>
          <div className="idea-scheduled-header-button-holder">
            <img onClick={moveBackAMonth} className="idea-schedule-icon month-skip" id='back-month' src="./images/next.png"></img>
            <img onClick={moveToNextMonth} className="idea-schedule-icon month-skip" id='forward-month' src="./images/next.png"></img>
          <button className="close close-btn" onClick={close} aria-label="Close">
            <svg width="16" height="16" viewBox="0 0 16 16" fill="none"><path d="M1 1l14 14M15 1L1 15" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/></svg>
          </button>
          </div>
        </div>
        <CalendarGrid time={monthToDisplay} SetSelectedScheduledDate={SetSelectedScheduledDate} expandedBool={false}/>

        <div className="scheduler-time-picker">
          <label className="scheduler-time-label small-text">Time</label>
          <select
            className="scheduler-time-input small-text"
            value={effectiveTime}
            onChange={(e) => setSelectedTime(e.target.value)}
          >
            {timeOptions.map((t, i) => (
              <option key={i} value={t}>{t}</option>
            ))}
          </select>
        </div>

        <div className="scheduler-button-holder">
          {linkedinStatus === "connected" ? (
            <>
              <Button text="Schedule in Mako" addedFunction={logScheduledDate} params={selectedScheduledDate} />
              <Button text="Schedule post to LinkedIn" image="./images/linkedin.png" addedFunction={logScheduledDateWithLinkedin} params={selectedScheduledDate} />
            </>
          ) : (
            <Button text="Schedule post" addedFunction={logScheduledDate} params={selectedScheduledDate} />
          )}
        </div>
        </div>
    </div>
  }

export default IdeaScheduler;
